<div class="flex flex-col bg-card overflow-hidden height-100p">
  <div class="dispositions-panel">
    <div
      class="pl-3 pr-3 pt-2 pb-2 border-b flex items-center"
      appAccountColorBackground
      #backgroundDirective="appAccountColorBackground"
      [colorName]="panelDef?.color"
    >
      <div class="flex items-center flex-auto" *ngIf="changeTitleMode">
        <app-form-field [fieldDef]="titleFieldDef" [model]="project" (onUpdate)="update($event)"></app-form-field>
      </div>
      <div class="flex flex-col">
        <div
          *ngIf="!changeTitleMode"
          class="font-bold text-md text-secondary uppercase tracking-wider"
          [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'"
        >
          {{ panelDef.title }}
        </div>
      </div>
      <div class="ml-auto">
        <button
          *ngIf="!readonly && !changeTitleMode"
          mat-icon-button
          (click)="openAddDispositionGroupModal()"
          [matTooltip]="'Add Disposition Group'"
          [appAuthorize]="NewPermission.DISPOSITIONS_CREATE"
          denyAction="disable"
        >
          <mat-icon
            [svgIcon]="'add'"
            [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'"
          ></mat-icon>
        </button>
        <button
          mat-icon-button
          type="button"
          *ngIf="!changeTitleMode && canEditPanelDef"
          [matMenuTriggerFor]="listCardMenu"
        >
          <mat-icon
            class="icon-size-20"
            [svgIcon]="'more_vert'"
            [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'"
          ></mat-icon>
        </button>
        <mat-menu #listCardMenu="matMenu">
          <button mat-menu-item (click)="toggleChangeTitleMode()" type="button">
            <mat-icon [svgIcon]="'edit'"></mat-icon>
            Change Panel Heading
          </button>
          <button mat-menu-item [matMenuTriggerFor]="toggleLabelMenu" type="button">
            <mat-icon [svgIcon]="'color_lens'"></mat-icon>
            Heading Color
          </button>
          <mat-menu class="mailbox-details-toggle-label-menu-panel" #toggleLabelMenu="matMenu">
            <div
              mat-menu-item
              class="gap-2"
              *ngFor="let color of accountColors$ | async"
              (click)="selectHeaderColor(color.name)"
            >
              <ts-color-bubble [hexColor]="color.hex_value"></ts-color-bubble>
              {{ color.label }}
            </div>
          </mat-menu>
        </mat-menu>
        <button
          *ngIf="changeTitleMode"
          class="cancel-button"
          mat-icon-button
          type="button"
          [matTooltip]="'Cancel'"
          (click)="toggleEditMode(false)"
        >
          <mat-icon
            [svgIcon]="'cancel'"
            [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'"
          ></mat-icon>
        </button>
        <button *ngIf="changeTitleMode" mat-icon-button type="submit" (click)="saveLayout()" [matTooltip]="'Save'">
          <mat-icon
            [svgIcon]="'save'"
            [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'"
          ></mat-icon>
        </button>
      </div>
    </div>
    <div class="flex flex-col dispositions-panel__body">
      <cdk-virtual-scroll-viewport itemSize="10" class="vscroll">
        <mat-expansion-panel
          [disabled]="clickButton"
          (click)="clickButton = false"
          [togglePosition]="'before'"
          *cdkVirtualFor="let group of dispositionGroups"
        >
          <mat-expansion-panel-header>
            <mat-panel-title class="dispositions-panel-title" style="justify-content: space-between; flex-basis: 0">
              {{ group.name }}
            </mat-panel-title>
            <mat-panel-description
              style="
                justify-content: space-between;
                flex-basis: 0;
                align-items: center;
                justify-content: flex-end;
                margin-right: 0px;
              "
            >
              <button
                mat-icon-button
                type="button"
                *ngIf="!changeTitleMode"
                [matMenuTriggerFor]="listCard99Menu"
                (click)="clickButton = true"
              >
                <mat-icon class="icon-size-20" [svgIcon]="'more_vert'"></mat-icon>
              </button>
              <mat-menu #listCard99Menu="matMenu">
                <button mat-menu-item (click)="openAddDispositionModal(group)" type="button">
                  <mat-icon [svgIcon]="'add'"></mat-icon>
                  Add Disposition
                </button>
                <button mat-menu-item (click)="openEditDispositionGroupModel(group)" type="button">
                  <mat-icon [svgIcon]="'edit'"></mat-icon>
                  Edit Group
                </button>
                <button mat-menu-item (click)="deleteGroup(group)" type="button">
                  <mat-icon [svgIcon]="'delete'"></mat-icon>
                  Delete Group
                </button>
              </mat-menu>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div style="display: flex; margin-bottom: 10px; align-items: center">
            <mat-icon style="margin-left: 10px" [svgIcon]="'people'" [matTooltip]="'Contacts'"></mat-icon>
            <mat-chip-list #chipList style="margin-left: 25px">
              <mat-chip *ngIf="group.seller_broker" matTooltipPosition="above" [matTooltip]="'Seller Broker'">
                {{ group.seller_broker.name }}
              </mat-chip>
              <mat-chip *ngIf="group.buyer_broker" matTooltipPosition="above" [matTooltip]="'Buyer Broker'">
                {{ group.buyer_broker.name }}
              </mat-chip>
              <mat-chip *ngIf="group.buyer" matTooltipPosition="above" [matTooltip]="'Buyer'">
                {{ group.buyer.name }}
              </mat-chip>
            </mat-chip-list>
          </div>
          <div style="display: flex; margin-bottom: 10px; align-items: center">
            <mat-icon style="margin-left: 10px" [svgIcon]="'description'" [matTooltip]="'Notes'"></mat-icon>
            <div class="disposition-note">{{ group.description }}</div>
          </div>
          <app-dispositions-table
            [dispositionGroup]="group"
            [project]="project"
            [options]="data.options"
          ></app-dispositions-table>
        </mat-expansion-panel>
      </cdk-virtual-scroll-viewport>
    </div>
  </div>
</div>
